<template>
    <div class="guide-tab-container">
        <div ref="mainEl">
            <slot></slot>
        </div>
        <FixedContainer v-show="fixedRef">
            <slot></slot>
        </FixedContainer>
    </div>
</template>

<script >
// 引导tab容器，当tab不在屏幕范围时，显示吸顶
import FixedContainer from './fixed-container.vue';
import { ref, onMounted, onUnmounted } from 'vue-demi';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const fixedRef = ref(false);
  const mainEl = ref(null);

  /**
   * 更新按钮可见状态，当组件按钮不在屏幕范围时，显示浮底按钮
   */
  function calc() {
    fixedRef.value = isShowFixed(mainEl.value);
  }
  function isShowFixed(el) {
    if (!el || !el.getBoundingClientRect) {
      return false;
    }
    const {
      top
    } = el.getBoundingClientRect();
    return top < 0;
  }
  onMounted(() => {
    setTimeout(() => {
      calc();
      // 监听滚动
      window.addEventListener('scroll', calc);
    }, 1000);
  });
  onUnmounted(() => {
    window.removeEventListener('scroll', calc);
  });
  return {
    fixedRef,
    mainEl
  };
};
__sfc_main.components = Object.assign({
  FixedContainer
}, __sfc_main.components);
export default __sfc_main;
</script>
